module.exports = __webpack_public_path__ + "static/media/memvra-4.398170e0.png";